module.exports = __webpack_public_path__ + "static/fonts/iconfont.a04d74f0.ttf";